import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    ofHub,
    signalrConnected,
    signalrDisconnected,
    stopSignalRHub,
} from 'ngrx-signalr-core';
import { timer } from 'rxjs';
import {
    exhaustMap,
    filter,
    groupBy,
    map,
    mergeMap,
    takeUntil,
} from 'rxjs/operators';
import { registerSystemSignalrEvents } from '../system-events/system-events.actions';

const TEN_SECONDS = 10 * 1000;

@Injectable()
export class SignalRGlobalEffects {
    private actions$ = inject(Actions);

    whenSignalRDisconnected$ = createEffect(() =>
        this.actions$.pipe(
            ofType(signalrDisconnected),
            groupBy((action) => action.hubName),
            mergeMap((group) =>
                group.pipe(
                    exhaustMap((action) =>
                        timer(0, TEN_SECONDS).pipe(
                            map(() =>
                                registerSystemSignalrEvents({
                                    hubName: action.hubName,
                                    url: action.url,
                                    connectionAction: 'reconnect',
                                }),
                            ),
                            takeUntil(
                                this.actions$.pipe(
                                    ofType(signalrConnected),
                                    ofHub(action),
                                ),
                            ),
                        ),
                    ),
                    takeUntil(
                        this.actions$.pipe(
                            ofType(stopSignalRHub),
                            filter((action) => action.hubName === group.key),
                        ),
                    ),
                ),
            ),
        ),
    );
}
